import SiteNav from '@/components/organisms/SiteNav'
import FooterStub from '@/components/organisms/FooterStub'
import SiteButton from '@/components/atoms/SiteButton'

export function PricingUnimoBuildPage() {
    return (
        <div className="min-h-screen bg-unimo-stone">
            <div className="site-shell">
                <SiteNav />

                <nav className="pt-8 text-sm text-unimo-site-grey-500">
                    <a href="/pricing" className="underline">
                        Pricing
                    </a>{' '}
                    / unimoBuild
                </nav>

                <section className="pt-4">
                    <h1 className="max-w-2xl text-4xl font-medium text-unimo-slate lg:text-6xl">Your next site starts here.</h1>
                    <p className="mt-6 max-w-xl text-lg font-light text-unimo-slate lg:text-xl">
                        Bring your site to life with unimoBuild. Tell us what you’d like to model and we’ll talk through
                        the right setup and pricing for your project.
                    </p>
                </section>

                <section className="pt-section-headline-gap-bottom">
                    <div className="relative overflow-hidden rounded-site-panel border-[3px] border-unimo-site-cta bg-gradient-to-bl from-unimo-site-blue-light to-unimo-stone p-8 lg:p-10">
                        <div className="grid gap-8 lg:grid-cols-[1.15fr_1fr]">
                            <div>
                                <h2 className="text-3xl font-medium text-unimo-slate">unimoBuild</h2>
                                <p className="mt-4 text-lg font-light text-unimo-slate">
                                    Turn your site documents into a living 3D model.
                                </p>
                                <ul className="mt-6 space-y-2 text-sm font-light text-unimo-site-grey-700">
                                    <li>Import PDFs, screenshots, photos and IFC exports from Navisworks or Revit.</li>
                                    <li>Ask unimoBuild what you need, without specialist modelling training.</li>
                                </ul>
                            </div>
                            <div>
                                <h3 className="text-3xl font-medium text-unimo-slate">Contact us for pricing</h3>
                                <p className="mt-4 max-w-md font-light text-unimo-site-grey-700">
                                    Every project starts with a conversation. Share your plans and we’ll help you explore
                                    what unimoBuild can do for your site.
                                </p>
                                <SiteButton href="/contact?topic=pricing" className="mt-6 w-fit">
                                    Contact us
                                </SiteButton>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="border-t border-unimo-site-grey-300 py-section-gap">
                    <div className="flex flex-wrap items-center justify-between gap-6">
                        <p className="max-w-xl text-lg font-light text-unimo-slate">
                            Need live sensor data or reporting across a portfolio?{' '}
                            <span className="font-medium">unimoLive</span> and <span className="font-medium">unimoReport</span> are
                            available to discuss as part of your project.
                        </p>
                        <SiteButton href="/contact?topic=pricing" variant="ghost" className="w-fit">
                            Contact us
                        </SiteButton>
                    </div>
                </section>

                <FooterStub />
            </div>

        </div>
    )
}

export default PricingUnimoBuildPage
